import React from 'react';
import PropTypes from 'prop-types';
import { PieChart as RechartsPieChart, Pie, Cell } from 'recharts';
import PieChartLabel from './PieChartLabel';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

const PieChart = ({ sectionTitle, data, colors }) => {
  return (
    <div className="section-graph">
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">{sectionTitle}</h4>
      </ViewerPrimaryColorUserStyle>
      <RechartsPieChart width={240} height={240}>
        <Pie
          isAnimationActive={false}
          data={data}
          cx={120}
          cy={120}
          startAngle={90}
          endAngle={-275}
          outerRadius={80}
          fill="#8884d8"
          label={PieChartLabel}
          labelLine={false}
        >
          {
            data.map((entry, index) => {
              return (<Cell key={index} fill={colors[index].toString()} />);
            })
          }
        </Pie>
      </RechartsPieChart>
    </div>
  );
};

PieChart.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.number]))
  .isRequired,
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
};

export default PieChart;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/PieChart/PieChart.js